import { Observable } from "rxjs";
import { Injectable, inject } from "@angular/core";
import { HttpInterceptor, HttpResponse } from "@angular/common/http";
import { HttpRequest } from "@angular/common/http";
import { HttpHandler } from "@angular/common/http";
import { HttpEvent } from "@angular/common/http";
import { tap } from "rxjs/operators";

import { LoaderService } from "../../shared/services/loader/loader.service";
import { AuthService } from "@core/services/auth.service";
import { Router } from "@angular/router";
import { ToastService } from "@shared/services/toast/toast.service";

@Injectable()
export class HttpLoaderInterceptor implements HttpInterceptor {
	loaderService = inject(LoaderService);
	authService = inject(AuthService);
	router = inject(Router);
	toastService = inject(ToastService);

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		this.loaderService.show();
		return next.handle(request).pipe(
			tap(
				(event: HttpEvent<any>) => {
					if (event instanceof HttpResponse && event.status === 401) {
						this.loaderService.hide();
					}

					if (event instanceof HttpResponse) {
						this.loaderService.hide();
					}
				},
				() => {
					this.loaderService.hide();
				}
			)
		);
	}
}
